<template>
    <div class="bg-white p-6 shadow-sm hover:shadow-md">
        <h2 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🏫</span> Seat Distribution by Room Type
        </h2>
        <apexchart type="donut" height="350" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
export default {
    name: "classroom-lab-chart",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                labels: [],
                colors: ['#4F46E5', '#22C55E'],
                legend: {
                    position: 'bottom',
                    fontSize: '14px',
                    labels: {
                        colors: '#374151'
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => `${val.toFixed(1)}%`
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} seats`
                    }
                }
            }
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData)) return;
                const values = newData.map(item => item.value);
                const labels = newData.map(item => item.name);
                this.series = values;
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labels,
                };
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>